export default {"src":"/_next/static/media/22-icon.42203fbc.svg","height":38,"width":46,"blurWidth":0,"blurHeight":0};